import React from "react";
import { useAppDispatch } from "app/store";
import { openToast } from "app/store/trackingApp/toastSlice";

const optionsLocation = {
  enableHighAccuracy: true,
  timeout: 5000,
  maximumAge: 0,
};

const useGeoLocation = () => {
  const dispatch = useAppDispatch();
  const [locationUser, setLocationUser] = React.useState(null);

  React.useEffect(() => {
    navigator.permissions.query({ name: "geolocation" }).then((resp) => {
      const { state } = resp;
      if (state === "prompt") {
        navigator.geolocation.getCurrentPosition(
          (pos) => setLocationUser(pos.coords),
          (err) => {
            dispatch(
              openToast({
                type: "error",
                title: "Não foi possível buscar sua localização!",
              })
            );
            console.warn(`ERROR(${err.code}): ${err.message}`);
          },
          optionsLocation
        );
      }
      if (state === "granted") {
        navigator.geolocation.getCurrentPosition(
          (pos) => setLocationUser(pos.coords),
          (err) => {
            dispatch(
              openToast({
                type: "error",
                title: "Não foi possível buscar sua localização!",
              })
            );
            console.warn(`ERROR(${err.code}): ${err.message}`);
          },
          optionsLocation
        );
      }
    });
  }, []);

  return locationUser;
};

export default useGeoLocation;
